import { useState } from "react";
// Add Bootstrap Icons CSS to your index.html or App.js:
// <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css">

const StickyContactTree = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [hoveredIcon, setHoveredIcon] = useState(null);

    const socialLinks = [
        { 
            name: 'WhatsApp', 
            icon: 'bi-whatsapp', 
            url: 'https://wa.me/7904168568',
            color: 'bg-green-500 hover:bg-green-600'
        },
        // { 
        //     name: 'Telegram', 
        //     icon: 'bi-telegram', 
        //     url: 'https://t.me/username',
        //     color: 'bg-blue-400 hover:bg-blue-500'
        // },
        { 
            name: 'Email', 
            icon: 'bi-envelope-fill', 
            url: 'mailto:malarsbakers@gmail.com',
            color: 'bg-red-500 hover:bg-red-600'
        },
        { 
            name: 'Phone', 
            icon: 'bi-telephone-fill', 
            url: 'tel:+917904168568',
            color: 'bg-sky-400 hover:bg-sky-500'
        },
        // { 
        //     name: 'Messenger', 
        //     icon: 'bi-messenger', 
        //     url: 'https://m.me/username',
        //     color: 'bg-blue-600 hover:bg-blue-700'
        // }
    ];

    return (
        <div 
            className="fixed bottom-6 right-6 z-50 md:bottom-8 md:right-8"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* Hover Area Extension - Invisible bridge that covers entire tree area */}
            <div className="absolute bottom-0 right-0 w-20 h-80 -top-64" />

            {/* Main Contact Button */}
            <button className="w-14 h-14 rounded-full bg-gradient-to-br from-orange-600 to-orange-800 text-white shadow-2xl hover:shadow-ornge-500/50 hover:scale-110 transition-all duration-300 flex items-center justify-center text-xl relative z-10">
                <i className="bi bi-chat-dots-fill"></i>
            </button>

            {/* Social Icons Tree */}
            <div className={`absolute bottom-16 right-0 flex flex-col gap-3 transition-all duration-300 ${isHovered ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
                {socialLinks.map((social, index) => (
                    <div key={social.name} className="relative">
                        <a
                            href={social.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            onMouseEnter={() => setHoveredIcon(social.name)}
                            onMouseLeave={() => setHoveredIcon(null)}
                            className={`
                                w-12 h-12 rounded-full ${social.color} 
                                text-white shadow-lg
                                flex items-center justify-center text-lg
                                transition-all duration-300
                                ${isHovered ? 'translate-y-0 scale-100' : 'translate-y-5 scale-75'}
                                hover:scale-110 hover:shadow-xl
                                relative z-10
                            `}
                            style={{ 
                                transitionDelay: isHovered ? `${index * 50}ms` : '0ms'
                            }}
                        >
                            <i className={social.icon}></i>
                        </a>
                        
                        {/* Tooltip */}
                        {hoveredIcon === social.name && (
                            <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-xs px-3 py-1.5 rounded shadow-lg whitespace-nowrap z-50">
                                {social.name}
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StickyContactTree;